import React from 'react';

import { Stack, Text } from '@mantine/core';
import { useLocalization } from 'context/localization-context';
import { BillingPlanRetrieve, type GymTitle, SalesPortalPackageRetrieve } from 'types';
import { getSuccessorStartDate } from 'utils/date-functions';

import BillingPlanSummary from './BillingPlanSummary';
import PackageSummary from './PackageSummary';

const SalesPortalBillingPlan = ({
  gym,
  billingPlanData,
  packageData,
}: {
  gym: GymTitle | undefined;
  billingPlanData: BillingPlanRetrieve | undefined;
  packageData: SalesPortalPackageRetrieve | undefined;
}): JSX.Element => {
  const { dateFormat } = useLocalization(gym?.country);

  const successorPackage = packageData?.successorPackage;

  if (successorPackage) {
    successorPackage.startDate = getSuccessorStartDate(
      dateFormat,
      packageData.attendanceRules,
      packageData.startDate || undefined,
    );
  }
  const successorBillingPlan = packageData?.successorBillingPlan;

  return (
    <Stack spacing='lg' px='lg'>
      {packageData && <PackageSummary pckg={packageData} hasBackButton />}

      {billingPlanData && (
        <BillingPlanSummary
          gym={gym}
          billingPlan={billingPlanData}
          taxRate={packageData?.taxRate?.rate || 0}
        />
      )}
      {successorPackage && successorBillingPlan && (
        <>
          <Text color='dark.8' fw={600} truncate>
            Following Package and Billing Plan
          </Text>
          <PackageSummary pckg={successorPackage} />
          <BillingPlanSummary
            gym={gym}
            billingPlan={successorBillingPlan}
            taxRate={successorPackage.taxRate?.rate || 0}
          />
        </>
      )}
    </Stack>
  );
};

export default SalesPortalBillingPlan;
